
import { useTranslation } from "react-i18next";
import { LicenceLeftMenu } from "../components/LicenceLeftMenu";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadListView } from "../components/TableStructure";
import { headerHeight } from "../utils/constants";

const List = [
  {
    fileStoreId: "49dac079-85c3-48a9-9ad2-3d54c81573be",
    label: "Ceremonial House Application Form & Instruction",
  },
  {
    fileStoreId: "431ba08f-7f0b-443f-97fd-cadfd897103a",
    label:
      "Application Form for Obtaining Of Enlistment (Trade Licence) For P/ Trades /Callings",
  },
  {
    fileStoreId: "6f88a75d-fb28-47bf-8f80-77e64a17fcf1",
    label: "Licence Self Declaration Format for Obtaining New C.E",
  },
];

const Licence_download_form = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2"></div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1" 
        style={{ minHeight: `calc(100vh - ${headerHeight}px)` }}>
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <LicenceLeftMenu />
              </div>
            </div>
            <div className="col-lg-9">
              <div className="inner-title2">
                <h3 className="fontSizeClass">Download Forms</h3>
              </div>
              <div className="col-lg-12 about-head1">
                <div
                  className="dig-login1 dig-form"
                  style={{ padding: " 16px 0px" }}
                >
                  <DownloadListView list={List} t={t} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Licence_download_form;
